module.exports = __webpack_public_path__ + "img/pin_substitution_orange.6d5531cd.svg";